// Auth API - HTTP client for authentication endpoints

export interface AuthUser {
  id: number;
  email: string;
  name: string;
  avatar_url: string | null;
  role: string;
}

export class AuthError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = 'AuthError';
    this.status = status;
  }
}

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, {
    credentials: 'include',
    ...init,
  });
  if (!response.ok) {
    if (response.status === 401) {
      throw new AuthError('Not authenticated', 401);
    }
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error((body as { error?: { message?: string } | string }).error
      ? typeof (body as { error: { message?: string } | string }).error === 'string'
        ? (body as { error: string }).error
        : ((body as { error: { message?: string } }).error as { message?: string }).message ?? `Request failed: ${response.status}`
      : `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getCurrentUser(): Promise<AuthUser> {
  return fetchJson<AuthUser>('/api/auth/me');
}

export async function logout(): Promise<void> {
  await fetch('/api/auth/logout', {
    method: 'POST',
    credentials: 'include',
  });
}
